@if (tradable !== null || multichainTradable !== null) {
  <div [tabindex]="0" class="tradable-amount-tile focus-link">
    <div class="tradable-amount-tile-amount-container">
      <div class="tradable-amount-tile-amount-big">
        @if (inverse && !all) {
          <span>
            {{
            tradableAmount
            | tradable_precision_symbol
            : {
            removePrecision: removePrecision,
            id: tradable ? tradable.getId() : multichainTradable.cryptocoin_id.toString()
          }
          }}
        </span>
      }
      @if (!inverse && !all) {
        <span>
          {{ getAmount() | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat] } }}
        </span>
      }
      @if (all) {
        <span>{{ "maximum" | translate }}</span>
      }
    </div>
    @if (showSmallAmount) {
      <div class="tradable-amount-tile-amount-small">
        @if (!inverse) {
          @if (!all) {
            &asymp;
          }
          {{
          tradableAmount
          | tradable_precision_symbol
          : {
          removePrecision: removePrecision,
          id: tradable ? tradable.getId() : multichainTradable.cryptocoin_id.toString(),
          ignorePrecision: removePrecision ? false : all,
          removeCurrency: tradable && tradable.getCurrencyType() === assetType.SECURITY_TOKEN
        }
        }}
        @if (tradable && tradable.getCurrencyType() === assetType.SECURITY_TOKEN) {
          <security-token-unit-display
          [amount]="tradableAmount"></security-token-unit-display>
        }
      }
      @if (inverse) {
        {{ getAmount() | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat] } }}
      }
    </div>
  }
</div>
</div>
}
